import React from 'react';
import InstrumentalResearchesTable from './Components/InstrumentalResearchesTable';

const InstrumentalResearchesPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <InstrumentalResearchesTable />
      </div>
    </div>
  );
};

export default InstrumentalResearchesPage;
